import styled from 'styled-components';

export const SuccessText = styled.div`
  & > strong {
    color: ${({ theme }) => theme.expensesSuccess.color};
    font-weight: 600;
  }
`;
